import * as userApi from "../api/user";
import { initiateVirtualCardCreation } from '../api/api';
import {
  setUser,
  setDashboard,
  setUserAndDashboard,
} from "../redux/slices/userSlice";
// import { startLoading, stopLoading } from '../redux/slices/loadingSlice';

// ✅ Update only user
export const refreshUserDetails = async (dispatch) => {
  try {
    const { data } = await userApi.getUserProfile();
    const user = data.data.user;

    dispatch(setUser(user));

    return user;
  } catch (error) {
    // console.error('Failed to refresh user:', error);
  }
};

// ✅ Update only dashboard
export const refreshDashboardDetails = async (dispatch) => {
  try {
    const { data } = await userApi.getUserDashboardInfo();
    const dashboard = data.data.user;
    dispatch(setDashboard(dashboard));
    return dashboard;
  } catch (error) {
    // console.error('Failed to refresh dashboard:', error);
  }
};

// ✅ Update both user and dashboard
export const getUserDetails = async (dispatch) => {
  try {
    refreshUserDetails(dispatch);
    // refreshDashboardDetails(dispatch);

    // const { data } = await userApi.getAuthenticatedUser();
    // const user = data.data.user;
    // const dashboard = data.data.dashboard;

    // dispatch(setUserAndDashboard({ user, dashboard }));

    // return { user, dashboard };
  } catch (error) {
    // console.error('Failed to fetch authenticated user:', error);
  }
};

export const createTransactionPin = async (
  credentials,
  setLoading,
  setSuccessMessage,
  setIsEdited,
  dispatch,
) => {
  setLoading(true);
  try {
    const { data } = await userApi.setTransactionPin(credentials);
    // console.log(data);
    setSuccessMessage("Your PIN has been updated successfully!");
    setIsEdited(false);
    setTimeout(() => setSuccessMessage(""), 10000);
    getUserDetails(dispatch);
  } catch (error) {
    setLoading(false);
    throw error;
  } finally {
  }
};

export const initiateKycFlow = async (credentials) => {
  try {
    const { data } = await userApi.initiateKyc(credentials);
    return data;
  } catch (error) {
    // console.error('KYC initiation failed:', error);
    throw new Error("KYC could not be started due to an error that ocurred");
  }
};

export const verifyGovtID = async (credentials) => {
  try {
    const { data } = await userApi.verifyGovernmentId(credentials);
    return data;
  } catch (error) {
    // console.error('Account upgrade initiation failed:', error);
    throw new Error(
      "Account upgrade could not be started due to an error that ocurred",
    );
  }
};

export const initiateVirtualAccountSetup = async (credentials, toast) => {
  try {
    const { data } = await userApi.setupVirtualAccount(credentials);
    return data;
  } catch (error) {
    let msg = "Virtual account creation failed";
    if (error.response.data.message) {
      msg = error.response.data.message;
    }
    toast.error(msg);
    // throw new Error(msg);
  }
};

export const updatingKycDetails = async (kyc_reference_id) => {
  try {
    const { data } = await userApi.updateKycDetails();
    // const { data } = await userApi.updateKycDetails(kyc_reference_id);
    // console.log(data);
  } catch (error) {
    // console.error('KYC updating failed:', error);
    // throw new Error("KYC updating failed");
  }
};

export const updateTier2KycInfo = async (payload) => {
  try {
    const { data } = await userApi.updateTier2KycInfo(payload);
    return data;
  } catch (error) {
    const message = error?.response?.data?.message || "Failed to save address and income information";
    throw new Error(message);
  }
};

export const uploadTier2KycDocument = async (formData) => {
  try {
    const { data } = await userApi.uploadTier2KycDocument(formData);
    return data;
  } catch (error) {
    const message = error?.response?.data?.message || "Failed to upload document";
    throw new Error(message);
  }
};

export const submitTier2Kyc = async () => {
  try {
    const { data } = await userApi.submitTier2Kyc();
    return data;
  } catch (error) {
    const message = error?.response?.data?.message || "Failed to submit Tier 2 KYC";
    throw new Error(message);
  }
};

export const fetchKybSummary = async () => {
  try {
    const { data } = await userApi.getKybSummary();
    return data;
  } catch (error) {
    throw error;
  }
};

export const fetchKybOnboardingOptions = async (countryCode) => {
  try {
    const { data } = await userApi.getKybOnboardingOptions(countryCode);
    return data;
  } catch (error) {
    throw error;
  }
};

export const submitKybBasicInfo = async (formData) => {
  try {
    const { data } = await userApi.updateKybBasicInfo(formData);
    return data;
  } catch (error) {
    throw error;
  }
};

export const submitKybAddress = async (credentials) => {
  try {
    const { data } = await userApi.updateKybAddress(credentials);
    return data;
  } catch (error) {
    throw error;
  }
};

export const submitKybDocument = async (formData) => {
  try {
    const { data } = await userApi.uploadKybDocument(formData);
    return data;
  } catch (error) {
    throw error;
  }
};

export const deleteKybDocument = async (documentId) => {
  try {
    const { data } = await userApi.deleteKybDocument(documentId);
    return data;
  } catch (error) {
    throw error;
  }
};

export const submitKybDirector = async (credentials) => {
  try {
    const { data } = await userApi.storeKybDirector(credentials);
    return data;
  } catch (error) {
    throw error;
  }
};

export const updateKybDirector = async (directorId, credentials) => {
  try {
    const { data } = await userApi.updateKybDirector(directorId, credentials);
    return data;
  } catch (error) {
    throw error;
  }
};

export const updateKybDirectorAddress = async (directorId, credentials) => {
  try {
    const { data } = await userApi.updateKybDirectorAddress(
      directorId,
      credentials,
    );
    return data;
  } catch (error) {
    throw error;
  }
};

export const markDirectorAsPrimaryOwner = async (directorId) => {
  try {
    const { data } = await userApi.markDirectorAsPrimaryOwner(directorId);
    return data;
  } catch (error) {
    throw error;
  }
};

export const sendDirectorKycRequest = async (directorId) => {
  try {
    const { data } = await userApi.sendDirectorKycRequest(directorId);
    return data;
  } catch (error) {
    throw error;
  }
};

export const deleteKybDirector = async (directorId) => {
  try {
    const { data } = await userApi.deleteKybDirector(directorId);
    return data;
  } catch (error) {
    throw error;
  }
};

export const submitKybRequest = async () => {
  try {
    const { data } = await userApi.submitKybRequest();
    return data;
  } catch (error) {
    throw error;
  }
};

export const completeDirectorKyc = async (kycRef, payload = {}) => {
  try {
    const { data } = await userApi.completeDirectorKyc(kycRef, payload);
    return data;
  } catch (error) {
    throw error;
  }
};

export const updateDirectorKycStatus = async (kycRef, formData) => {
  try {
    const { data } = await userApi.updateDirectorKycStatus(kycRef, formData);
    return data;
  } catch (error) {
    throw error;
  }
};

export const updateBusinessDirectorInvite = async (invitationReference, credentials) => {
  try {
    const { data } = await userApi.updateBusinessDirectorInvite(invitationReference, credentials);
    return data;
  } catch (error) {
    throw error;
  }
};

export const addWallet = async (
  credential,
  setAddWalletLoading,
  setWalletSelect,
  toast,
  setIsEdited,
  dispatch,
  fetchAllWallets,
  setWalletAdded,
  closeWalletDeleteRef,
) => {
  setAddWalletLoading(true);
  try {
    const response = await userApi.addWallet(credential);
    // console.log(response.data)

    const user = await refreshUserDetails(dispatch);
    // console.log(user);

    if (user) {
      toast.success("Wallet Created Successfully", {
        toastId: "addWallet-success-toast",
        className: "custom-toast",
      });

      fetchAllWallets();
      setWalletAdded(true);
      setWalletSelect("");
      setIsEdited(false);
      closeWalletDeleteRef?.current?.click();
    }

    return true;
  } catch (error) {
    const responseErrors = error?.response?.data?.errors;
    const fallbackMessage =
      error?.response?.data?.message || "Error Creating Wallet";

    if (responseErrors && Object.keys(responseErrors).length > 0) {
      const errorMessages = Object.values(responseErrors)
        .flat()
        .filter(Boolean);

      toast.error(
        errorMessages.length > 1
          ? errorMessages[0]
          : errorMessages.join("<br/>"),
        {
          toastId: "addWallet-fail-toast",
        },
      );
    } else {
      toast.error(fallbackMessage, {
        toastId: "addWallet-fail-toast",
      });
    }

    // console.error('Error fetching wallets:', error);
    return false;
  } finally {
    setAddWalletLoading(false);
  }
};

export const deleteUserWallet = async (
  walletId,
  setDeleteLoading,
  toast,
  dispatch,
  getUserWallets,
  closeWalletDeleteRef,
) => {
  setDeleteLoading(true);
  try {
    const response = await userApi.deleteWallet(walletId);
    // console.log(response.data)
    const user = await refreshUserDetails(dispatch);
    if (user) {
      toast.success("Wallet Deleted Successfully", {
        toastId: "deleteWallet-success-toast",
        className: "custom-toast",
      });

      // fetchAllWallets();
      getUserWallets(user.wallet);
      closeWalletDeleteRef?.current?.click();
    }

    return true;
  } catch (error) {
    const responseErrors = error?.response?.data?.errors;
    const fallbackMessage =
      error?.response?.data?.message || "Error Deleting Wallet.";

    if (responseErrors && Object.keys(responseErrors).length > 0) {
      const errorMessages = Object.values(responseErrors)
        .flat()
        .filter(Boolean);

      toast.error(
        errorMessages.length > 1
          ? errorMessages[0]
          : errorMessages.join("<br/>"),
      );
    } else {
      toast.error(fallbackMessage, {
        toastId: "deleteWallet-fail-toast",
      });
    }
    return false;
  } finally {
    setDeleteLoading(false);
  }
};

export const phoneVerificationRequest = async (credentials) => {
  try {
    const response = await userApi.phoneVerificationRequest(credentials);
    // console.log(response.data)
    return response.data;
  } catch (error) {
    // console.error('Error fetching wallets:', error);
    throw error;
  }
};

export const phoneNumberVerification = async (credentials) => {
  try {
    const response = await userApi.phoneNumberVerification(credentials);
    // console.log(response.data)
    return response.data;
  } catch (error) {
    // console.error('Error fetching wallets:', error);
    throw error;
  }
};

export const referralLeaderboard = async (perPage, page) => {
  try {
    const response = await userApi.referralLeaderboard(perPage, page);
    // console.log(response.data)
    return response.data;
  } catch (error) {
    // console.error('Error fetching referral leaderboard:', error);
    throw error;
  }
};

export const retrieveReferrals = async (perPage, page) => {
  try {
    const response = await userApi.retrieveReferrals(perPage, page);
    // console.log(response.data)
    return response.data;
  } catch (error) {
    // console.error('Error fetching referral leaderboard:', error);
    throw error;
  }
};

export const createSupportTicket = async (credentials) => {
  try {
    const response = await userApi.createSupportTicket(credentials);
    // console.log(response.data)
    return response.data;
  } catch (error) {
    // console.error('Error creating support ticket:', error);
    throw error;
  }
};

export const getSupportTickets = async (filter) => {
  try {
    const response = await userApi.getSupportTicketList(filter);
    // console.log(response.data)
    return response;
  } catch (error) {
    // console.error('Error fetching support tickets:', error);
    throw error;
  }
};

export const getSupportTicketDetails = async (ticketId) => {
  try {
    const response = await userApi.getSupportTicketDetails(ticketId);
    return response.data;
  } catch (error) {
    // console.error('Error fetching support ticket details:', error);
    throw error;
  }
};

export const supportReply = async (ticketId, message, attachment) => {
  try {
    const response = await userApi.supportReply(ticketId, message, attachment);
    // console.log(response.data)
    return response.data;
  } catch (error) {
    // console.error('Error posting support reply:', error);
    throw error;
  }
};

export const userWorkExperience = async (credentials) => {
  try {
    const response = await userApi.userWorkExperience(credentials);
    return response.data;
  } catch (error) {
    // console.error('Error creating work experience:', error);
    throw error;
  }
};

export const getUserWorkExperience = async (filter) => {
  try {
    const response = await userApi.getUserWorkExperience(filter);
    return response.data;
  } catch (error) {
    // console.error('Error fetching work experience:', error);
    throw error;
  }
};

export const userDocsUpload = async (credentials) => {
  try {
    const response = await userApi.userDocsUpload(credentials);
    return response.data;
  } catch (error) {
    // console.error('Error uploading documents:', error);
    throw error;
  }
};

export const getUserDocsUpload = async (filter) => {
  try {
    const response = await userApi.getUserDocsUpload(filter);
    return response.data;
  } catch (error) {
    // console.error('Error fetching uploaded documents:', error);
    throw error;
  }
};

export const userIncomeSources = async (credentials) => {
  try {
    const response = await userApi.userIncomeSources(credentials);
    return response.data;
  } catch (error) {
    // console.error('Error fetching income sources:', error);
    throw error;
  }
};

export const getUserIncomeSources = async (filter) => {
  try {
    const response = await userApi.getUserIncomeSources(filter);
    return response.data;
  } catch (error) {
    // console.error('Error fetching income sources:', error);
    throw error;
  }
};


export const createCard = async (credentials) => {
  try {
    const response = await initiateVirtualCardCreation(credentials);
    return response.data;
  } catch (error) {
    // console.error('Error creating card:', error);
    throw error;
  }
};